var exports = {
  "a": "branchName__supFYK",
};

module.exports = exports;
